<H1> Analog out<app-loader [status]="loaderStatus"></app-loader></H1>

<mat-tab-group>
  <div *ngFor="let y of [0,1,2,3,4,5,6,7]">{{y}}
    <mat-tab label="AO {{ 1+ (y * 32)}}- {{ (y+1) * 32}}" >

      <kendo-card class="analogout-card"  *ngFor="let tile of tiles; let i = index" >
        <kendo-card-header>
          <h1 kendoCardTitle>
            <kendo-icon name="clip"></kendo-icon>
           AO {{ (y*32)+ (i*8)+1 }} to  {{ (y*32)+ (i*8)+8 }}
          </h1>
        </kendo-card-header>
        <kendo-card-body>
          <div *ngFor="let x of [0,1,2,3,4,5,6,7]">
            <app-analogoutdetails [refNumber] = " (y*32)+ (i*8) + x" ></app-analogoutdetails>
          </div>
        </kendo-card-body>
      </kendo-card>

    </mat-tab>
  </div>
</mat-tab-group>


